import * as angular from 'angular';

import { ChartIdentifierWidgetConfiguration, ISeriesConfiguration, IdataWidget, WidgetWithErrors } from '../index';
import { Helper } from '../../common';
import { AggregationMode, WidgetValuesReadConfiguration, ReadType, IBindable, ColoringMode } from '../../models';
import { IwidgetIntervalHelperService } from '../../services';
import { gaugeChartDefinition as definition } from '../../widgets/widgets.definition.index';

export class GaugeChartWidget extends WidgetWithErrors implements IdataWidget {
    baseType = definition.baseType;
    col = 0;
    configuration: ChartIdentifierWidgetConfiguration;
    exportToCsv: () => angular.IPromise<any>;
    guid: string;
    hasExtendedProperties = true;
    highlights = definition.highlights;
    icon = definition.icon;
    isExportable = true;
    isMaximizable = true;
    isMaximized = false;
    name = definition.title;
    row = 0;
    sizeX = 4;
    sizeY = 18;
    type = definition.type;

    constructor(
        private _$q: angular.IQService,
        private _$translate: angular.translate.ITranslateService,
        intervalHelperService: IwidgetIntervalHelperService,
    ) {
        super(intervalHelperService);
        this.guid = Helper.getGuid();
        this.configuration = new ChartIdentifierWidgetConfiguration(this._$translate);
        this.configuration.options.coloringMode = ColoringMode.SingleColor;
        this.configuration.options.color = '#eee';
        this.configuration.options.title = 'Gauge';
        this.configuration.options.isLegendVisible = true;
        this.configuration.options.isLineVisible = true;
        this.configuration.isEndDateIncluded = false;
        this.configuration.options.thickness = 25;
        this.configuration.nameConfiguration.hasName = true;
        this.configuration.nameConfiguration.hasUnit = true;
        this.configuration.aggregation.mode = AggregationMode.Average;
    }

    getReadConfiguration(beginDate: string, endDate: string): WidgetValuesReadConfiguration {
        return this.getReadConfigurationBase(beginDate, endDate, this.configuration.series, this.configuration,
            this.configuration.aggregation,
            false, false, false,
            !!this.configuration.options.showTarget,
            false, ReadType.AggregatedValue, false,
            this.configuration.options.variableTypeGuid,
            this.configuration.options.unitGuid);
    }

    getReadConfigurationAsync(): angular.IPromise<WidgetValuesReadConfiguration> {
        return this.getSeriesListAsync()
            .then(data => {
                const hasQuality = false;
                const hasMissingRanges = false;
                const hasContext = false;
                const hasTendency = false;
                const aggregation = this.configuration.aggregation;
                const widgetValuesReadConfiguration = this.createConfiguration(
                    data, aggregation, hasQuality,
                    hasMissingRanges, hasContext,
                    hasTendency,
                    !!this.configuration.options.showTarget,
                    ReadType.AggregatedValue,
                    this.configuration.options.variableTypeGuid,
                    this.configuration.options.unitGuid
                );

                return widgetValuesReadConfiguration;
            });
    }

    private getSeriesListAsync(): angular.IPromise<IBindable[]> {
        const result = this.configuration.series.map(d => {
            return {
                guid: d.guid,
                originalGuid: d.guid,
                value: d.value,
                relativePath: d.relativePath,
                isBoundToGroup: d.isBoundToGroup
            };
        });
        return this._$q.when(result);
    }

    getSeries(): ISeriesConfiguration[] {
        return (this.configuration as any).series;
    }

    setSeries(series: ISeriesConfiguration[]) {
        (this.configuration as any).series = series;
    }
}